import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  SegmentStateType,
  SetQueryPayloadActionType,
  SetSegmentsPayloadActionType,
  SelectedSegmentType,
  SetModalPayloadActionType,
  SetSegmentGroupsPayloadActionType,
  SetSegmentGroupsABPayloadActionType,
  SetSelectedSegmentGroupsPayloadActionType,
} from 'features/Segmentation/@types/Segment'

export const SLICE_NAME = 'segmentation/segment'

const initialState: SegmentStateType = {
  isLoading: false,
  query: {
    pagination: {
      page_size: 0,
      next_page_exist: true,
      previous_page_exist: false,
      next_cursor: '',
      page_cursor: '',
      previous_cursor: '',
      cursor_direction: '',
      page_item: 0,
    },
    cursor: '',
    direction: '',
    limit: 20,
    name: '',
  },
  segments: [],
  segmentGroups: [],
  segmentGroupAB: [],
  selectedSegment: [],
  selectedSegmentGroup: null,
  modal: {
    mode: '',
  },
}

const segmentSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    reset: () => initialState,
    resetSegments: (state) => {
      state.segments = []
    },
    resetSelectedSegment: (state) => {
      state.selectedSegment = []
    },
    resetQuery: (state) => {
      state.query = initialState.query
    },
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setQuery: (state, action: PayloadAction<SetQueryPayloadActionType>) => {
      state.query = { ...state.query, ...action.payload }
    },
    setSegments: (state, action: PayloadAction<SetSegmentsPayloadActionType>) => {
      state.segments = action.payload
    },
    setSegmentGroups: (state, action: PayloadAction<SetSegmentGroupsPayloadActionType>) => {
      state.segmentGroups = action.payload
    },
    setSelectedSegmentGroup: (
      state,
      action: PayloadAction<SetSelectedSegmentGroupsPayloadActionType>,
    ) => {
      state.selectedSegmentGroup = action.payload
    },
    setSegmentGroupsAB: (state, action: PayloadAction<SetSegmentGroupsABPayloadActionType>) => {
      state.segmentGroupAB = action.payload
    },
    setCheckedSegmentIds: (
      state,
      action: PayloadAction<{ segments: SelectedSegmentType[]; isChecked: boolean }>,
    ) => {
      const { segments, isChecked } = action.payload
      if (isChecked) {
        state.selectedSegment.push(...segments)
      } else {
        state.selectedSegment = state.selectedSegment.filter(
          (id) => !segments.some((segment) => segment.segment_id === id.segment_id),
        )
      }
      state.segments = state.segments.map((segment) =>
        segments.some((selected) => selected.segment_id === segment.segment_id)
          ? { ...segment, is_checked: isChecked }
          : segment,
      )
    },
    setModal: (state, action: PayloadAction<SetModalPayloadActionType>) => {
      state.modal = { ...state.modal, ...action.payload }
    },
  },
})

export const {
  setIsLoading,
  reset,
  setQuery,
  setSegments,
  resetSegments,
  resetSelectedSegment,
  setCheckedSegmentIds,
  setModal,
  setSegmentGroups,
  setSegmentGroupsAB,
  setSelectedSegmentGroup,
  resetQuery,
} = segmentSlice.actions
export default segmentSlice.reducer
